import { defineStore } from 'pinia';
import { getConfigKeys } from '@/api/common';

type AppConfig = {
  sys_portal_url: string;
  aihub_domain: string;
  aihub_customer_service: string;
};

interface AppState {
  mode: 1 | 2;
  appConfig: AppConfig;
}

const useAppStore = defineStore('app', {
  state: (): AppState => ({
    mode: 2,
    appConfig: {
      sys_portal_url: '',
      aihub_domain: '',
      aihub_customer_service: '',
    },
  }),
  actions: {
    homeTimer() {
      setTimeout(() => {
        this.mode = 2;
      }, 5000);
    },
    initAppConfig() {
      getConfigKeys(Object.keys(this.appConfig).join(',')).then((res) => {
        const tempAppConfig: AppConfig = { ...this.appConfig };
        Object.keys(res.data).forEach((key) => {
          if (res.data[key]) {
            tempAppConfig[key] = res.data[key];
          }
        });
        this.appConfig = tempAppConfig;
      });
    },
  },
});

export default useAppStore;
